import React from "react";

import { BROWSE_ICONS_BY_TAG } from "data/links";

/* content for main Hero section: */
import HomeHeroIconsDesktopSvg from "./images/home-hero-icons-desktop.svg";
import HomeHeroIconsMobileSvg from "./images/home-hero-icons-mobile.svg";

export const heroTitle = "Icons and Photos For Everything";

export const heroSvgDesktop = HomeHeroIconsDesktopSvg;

export const heroSvgMobile = HomeHeroIconsMobileSvg;

/* content for Collections: */

// Collection Images:
import Textures from "./images/textures.jpg";
import SubmitYourPhotos from "./images/submit-your-photos.jpg";
import Family from "./images/family.jpg";
import FeaturedPhotographer from "./images/featured-photographer.jpg";
import BrowseNewIcons from "./images/browse-new-icons.svg";
import IconHouseplants from "./images/icon-houseplants.png";
import ArtificialIntelligence from "./images/artificial-intelligence.svg";
import IconSetIconathonSvg from "./images/icon-set-iconathon.svg";
import IconSetSpring from "./images/icon-set-spring.svg";

export const collectionsTitle =
    "Noun Project is building a global visual language that unites us.";

export const collections = [
    {
        title: "Iconathon",
        subtitle: "Redefining Women Collection",
        url: "/Iconathon1/collection/redefining-women/",
        imageSrcAndTitle: {
            imageSrc: IconSetIconathonSvg,
            title: "Iconathon"
        },
        type: "darkMode"
    },
    {
        title: "Submit Your Photos",
        subtitle: null,
        url: "/call-to-photographers/",
        imageSrcAndTitle: {
            imageSrc: SubmitYourPhotos,
            title: "Submit Your Photos"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Houseplants",
        subtitle: null,
        url: "/browse/icons/term/houseplants/",
        imageSrcAndTitle: {
            imageSrc: IconHouseplants,
            title: "Houseplants"
        },
        type: "primary"
    },
    {
        title: "Family",
        subtitle: null,
        url: "/search/photos/?q=family",
        imageSrcAndTitle: {
            imageSrc: Family,
            title: "Family"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "Artificial Intelligence",
        subtitle: null,
        url:
            "/browse/collection-icon/artificial-intelligence-by-essence-99758/?p=1",
        imageSrcAndTitle: {
            imageSrc: ArtificialIntelligence,
            title: "Artificial Intelligence"
        },
        type: "primary"
    },
    {
        title: "Textures",
        subtitle: null,
        url: "/search/photos/?q=textures",
        imageSrcAndTitle: {
            imageSrc: Textures,
            title: "Textures"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Spring",
        subtitle: null,
        url: "/browse/collection-icon/spring-210596/?p=1",
        imageSrcAndTitle: {
            imageSrc: IconSetSpring,
            title: "Spring"
        },
        type: "primary"
    },
    {
        title: "Featured Photographer",
        subtitle: null,
        url: "/browse/creator/tabitazn_sabina_aghova/photos/",
        imageSrcAndTitle: {
            imageSrc: FeaturedPhotographer,
            title: "Featured Photographer"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Browse New Icons",
        subtitle: null,
        url: "/browse/icons/recent/?p=1",
        imageSrcAndTitle: {
            imageSrc: BrowseNewIcons,
            title: "Browse New Icons"
        },
        type: "primary"
    }
];

export const pillsTitle = "Explore Trends";
export const pills = [
    "8-bit",
    "cloud",
    "education",
    "graph-chart",
    "love",
    "menu",
    "moon",
    "star",
    "thumbs-up",
    "travel"
].map(tag => ({
    title: tag
        .split("-")
        .map(word => word[0].toUpperCase() + word.slice(1))
        .join(" "),
    url: BROWSE_ICONS_BY_TAG.replace(":term", tag)
}));

/* content for Recent Posts: */
import TopPhotographers from "./images/top-photographers.jpg";
import IconDesign from "./images/icon-design-fundamentals.png";
import RecentPostsImg3 from "./images/design-icons-debbie-millman.jpg";

export const recentPostsTitle = "Recent Posts";

export const recentPosts = [
    {
        title: "Top Photographers of 2024",
        category: "Creative Inspiration",
        imgSrc: TopPhotographers,
        url: "https://photolist.thenounproject.com/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Icon Design Fundamentals",
        category: "Tutorial",
        imgSrc: IconDesign,
        url:
            "https://blog.thenounproject.com/icon-design-fundamentals-mastering-vector-editing-tools/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Design Icons: Debbie Millman",
        category: "Interview Feature",
        imgSrc: RecentPostsImg3,
        url: "https://blog.thenounproject.com/design-icons-debbie-millman/",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

/* Content for Promo section: */
import { PRICING, appsAndPluginsPath, API_LANDING_PAGE } from "data/links";
import Payouts from "core/ReusableIcons/Payouts";
import Computer from "core/ReusableIcons/Computer";
import Api from "core/ReusableIcons/Api";

import AppAppleSvg from "./images/AppAppleSvg";
import AppAdobeSvg from "./images/AppAdobeSvg";
import AppMicrosoftSvg from "./images/AppMicrosoftSvg";
import AppGsuiteSvg from "./images/AppGsuiteSvg";

export const promo = [
    {
        url: PRICING,
        iconName: <Payouts size="xl" title="Pricing &amp; Licenses" />,
        title: "Pricing & Licenses",
        description:
            "All images available as free downloads. Buy a royalty-free license to support artists and get more options.",
        learnMoreContent: "Learn More"
    },
    {
        url: appsAndPluginsPath,
        iconName: <Computer size="xl" title="Apps &amp; Plugins" />,
        title: "Apps & Plugins",
        description:
            "Drag and drop icons into the software you use. Access vector, png, & pdf from Mac, PowerPoint, Adobe, Google, more.",
        learnMoreContent: [
            {
                icon: <AppAppleSvg title="Apple" />
            },
            {
                icon: <AppAdobeSvg title="Adobe" />
            },
            {
                icon: <AppMicrosoftSvg title="Microsoft" />
            },
            {
                icon: <AppGsuiteSvg title="GSuite" />
            }
        ]
    },
    {
        url: API_LANDING_PAGE,
        iconName: <Api size="xl" title="API" />,
        title: "API",
        description:
            "Access the entire icon collection via our REST API. Reliably supports growth stage to enterprise clients. ",
        learnMoreContent: "Learn More"
    }
];
